<template>
  <div class="search-container">
    <input type="text" ref="input" v-model="value" @keyup.enter="enter()" :placeholder="placeholder">
    <div class="icon-container-close" v-if="value">
      <button @click.prevent="clear">
        <ion-icon name="close-outline"></ion-icon>
      </button>
    </div>

    <button class="icon-container" @click.prevent="enter()">
      <ion-icon name="search-outline"></ion-icon>
    </button>
  </div>
</template>

<script>
export default {
  name: 'Search',
  props: {
    placeholder: {
      type: String,
      default: 'search...'
    }
  },
  data() {
    return {
      value: null,
    }
  },
  watch: {
    $route(to) {
      this.setValue(to.query.search)
    },
  },
  mounted() {
    this.setValue(this.$route.query.search)
  },
  methods: {
    setValue(value) {
      this.value = value
    },
    clear() {
      this.value = null
    },
    enter() {
      this.$emit('enter',this.value)
    },
  }
}
</script>


<style scoped lang="scss">
@import 'D:\\inetpub\\MPortal\\src\\_variables';
.search-container {
  position: relative;
  display: flex;
  flex-direction: row;
  border-radius: 16px;
  min-width: 344px;

}
.icon-container {
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
  border: 1px solid $border_light;
  border-left: none;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 32px;
  padding: .25rem 1rem;
  background-color: $background_light_1;
  cursor: pointer;
}
.icon-container-close {
  height: 100%;
  width: 32px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  right: 66px;
  z-index: 3;
  button {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 38px;
    height: 38px;
    font-size: 32px;
    cursor: pointer;
    border-radius: 100%;
    &:hover {
      background: $background_light_transparent;
    }
    &:active {
      background: $background_light_transparent_1;
    }
  }
  }

input {
  width: 100%;
  border: none;
  outline: none;
  padding: .75rem 1.55rem .75rem 1.5rem;
  background-color: $background_light;
  font-size: 1rem;
  border-top-left-radius: 16px;
  border-bottom-left-radius: 16px;
  border: 1px solid $border_light;
  z-index: 2;
  &:focus {
    border: 1px solid $kit_green;
    outline: 1px solid $kit_green;
  }
}
</style>
